import React from 'react';
import Button from '../Button/Button';
import Modal from '../Modal/Modal';
import { ReactComponent as CloseIcon } from '../../images/Close.svg';

function ConfirmationModal({ onCancel, onConfirm, text, office, location, open, children, style, hasCloseButton }) {
  //TODO take out fallback text
  return (
    <Modal open={open} onClose={onCancel} style={style}>
      <div className="mod2" style={{ minWidth: 'unset' }}>
        {office && location && (
          <div className="mod2header">
            <div>
              {office && <p>{office}</p>}
              {location && <p>{location}</p>}
            </div>
            {hasCloseButton && (
              <CloseIcon
                style={{
                  fill: 'black',
                  marginRight: '30px',
                  cursor: 'pointer',
                }}
                onClick={onCancel}
              />
            )}
          </div>
        )}
        <div className="centerer">
          {children && children}
          <p>{text}</p>
          {!hasCloseButton && (
            <div>
              <Button text="Cancel" onClick={onCancel} />
              <Button text="Confirm" onClick={onConfirm} />
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
}

export default ConfirmationModal;
